import { ExportOutlined, EyeOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Space } from "antd";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { COMMERCIAL_PACKING_REQUIREMENTS } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { alertPop } from "../../../apiServices/common/helper";
import {
  COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION,
  COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION,
} from "../../../routes/permissions";
import { hasPermission } from "../../../utils/functions";
import { isMobileView } from "../../Common/AppHelper";
import BodyHeader from "../../Common/BodyHeader";
import CustomFilter from "../../Common/CustomFilter";
import Header from "../../Common/Header";
import ListTable from "common/ListTable";

export default function CommercialPackingRequirement(props) {
  // Props
  const { width } = props;

  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  //   States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [
    commercialPackingRequirementList,
    setCommercialPackingRequirementList,
  ] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rangeData, setRangeData] = useState();

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const searchFilter = (values) => {
    console.log("values", values);
  };

  const columns = [
    {
      title: "Original PO",
      dataIndex: ["po_maps", "original_po"],
      key: ["po_maps", "original_po"],
    },
    {
      title: "Internal PO",
      dataIndex: ["po_maps", "internal_po"],
      key: ["po_maps", "internal_po"],
    },
    {
      title: "Sales Contract",
      dataIndex: ["sales_contract", "reference_no"],
      key: "sales_contract",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => openForView(record.id)}
              icon={<EyeOutlined />}
              disabled={
                !hasPermission([COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION])
              }
              className="mr-2"
            >
              View
            </Button>
            <Button
              size="small"
              onClick={() => openForEdit(record.id)}
              icon={<ExportOutlined />}
              disabled={
                !hasPermission([COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION])
              }
            >
              Edit
            </Button>
          </Space>
        );
      },
    },
  ];

  const getAll = async (passedObject) => {
    let filter = passedObject;
    setError(null);
    let response = await getData(
      COMMERCIAL_PACKING_REQUIREMENTS,
      false,
      filter,
    );

    if (response && response?.status === 200) {
      let masterData = response?.data;
      setCommercialPackingRequirementList(masterData?.data?.data);
      setTotalData(masterData?.data?.total);
      setRangeData(masterData?.data?.per_page);
    } else {
      setError("Could not load this list.");
      alertPop(
        "error",
        response?.messages ? response?.messages : "Something Went Wrong!",
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getAll({ page: currentPage });
  }, [currentPage]);

  const openForEdit = (id) => {
    navigate(`/export/commercial-packing-requirement/update/${id}`);
  };

  const openForView = (id) => {
    navigate(`/export/commercial-packing-requirement/view/${id}`);
  };

  const paginate = (page) => {
    setCurrentPage(page);
  };

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        tableData={commercialPackingRequirementList}
        fetchTableData={getAll}
        filterName="commercial_packing_requirement"
      />
    ),
    [showFilter],
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Commercial Packing Requirement"
            subTitle=""
            actions={[
              <Button
                type={showFilter ? "danger" : "primary"}
                size="small"
                onClick={handleFilter}
                style={{ float: "right" }}
              >
                {`${showFilter ? "Close" : "Open"} Filter Option`}
              </Button>,
              // <Button
              //   key="3"
              //   size="small"
              //   type="primary"
              //   disabled={!hasPermission([EXPORT_DETAILS_CREATE_PERMISSION])}
              // >
              //   <Link to="/export/add-export-details">
              //     {hasPermission([EXPORT_DETAILS_CREATE_PERMISSION])
              //       ? "Add New"
              //       : "No Permission"}
              //   </Link>
              // </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          <BodyHeader searchFilter={searchFilter} />
          {memoizedCustomFilter}
          <ListTable
            loading={loading}
            error={error}
            onRetry={() => getAll({ page: currentPage })}
            emptyText="No records to show yet."
            dataSource={commercialPackingRequirementList}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
}
